module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 24
// module chunks = 0 1 2